import App from '@/models/App'

export default class TrafficShipFormItem extends App {
    static get entity() {
        return 'TrafficShipFormItems'
    }

    static all() {
        return this.query().withAllRecursive().where('isDeleted', false).get()
    }

    static fields() {
        return {
            id: this.attr(''),
            trafficShipFormFormatId: this.attr(''),
            name: this.attr(''),
            isRequired: this.attr(''),
            type: this.attr(''),
            sortNum: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            destroy(trafficShipFormItemId) {
                return this.delete(
                    `traffic/ship/form/items/${trafficShipFormItemId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
